import { render, staticRenderFns } from "./profiles.vue?vue&type=template&id=28885ae9&scoped=true&"
import script from "./profiles.vue?vue&type=script&lang=js&"
export * from "./profiles.vue?vue&type=script&lang=js&"
import style0 from "./profiles.vue?vue&type=style&index=0&id=28885ae9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28885ae9",
  null
  
)

export default component.exports